import React, { Component } from 'react';
import YearSelector from '../../components/Selector/YearSelector';
import Selector from '../../components/Selector';
import { Checkbox } from 'antd';
import { ConfigProvider, Space } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';

class GutschriftProductTableFilter extends Component {

    state = {
        selectedCreatedYear: new Date().getFullYear(),
        need_gutschrift: 1,
        received_gutschrift: 0,
        brand_id: null,
    }

    changeSelectedCreatedYear = (event) => {
        this.setState({ selectedCreatedYear: event.target.value });
        this.props.getProducts(this.state.need_gutschrift, this.state.received_gutschrift, event.target.value, this.state.brand_id);
    }

    onChangeNeedgutschrift = (e) => {
        this.setState({
            need_gutschrift: e.target.checked ? 1 : 0
        });
        let need_gutschrift = e.target.checked ? 1 : 0;
        this.props.getProducts(need_gutschrift, this.state.received_gutschrift, this.state.selectedCreatedYear, this.state.brand_id);
    }

    onChangeReceivedGutschrift = (e) => {
        this.setState({
            received_gutschrift: e.target.checked ? 1 : 0
        });
        let received_gutschrift = e.target.checked ? 1 : 0;
        this.props.getProducts(this.state.need_gutschrift, received_gutschrift, this.state.selectedCreatedYear, this.state.brand_id);
    }

    changeProductBrand = (value) => {
        let brand_id = value;
        if (brand_id == undefined) {
            brand_id = null;
        }
        this.setState({
            brand_id: brand_id
        });
        this.props.getProducts(this.state.need_gutschrift, this.state.received_gutschrift, this.state.selectedCreatedYear, brand_id);
    }

    render() {

        const { brands } = this.props;

        return (

            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#2b3e50',
                    }
                }}
            >
                <StyleProvider hashPriority="high">
                    <tr>
                        <td></td>
                        <td></td>
                        <td>
                        </td>
                        <td>
                            {/* <Selector name='Client' defaultValue={React.Component.prototype.$intl.get('请选择客户')} selectorValues={clients} changeSelector={this.changeSelectedClient.bind(this)} selectedValue={this.state.selectedClient} />
                            
                            <Checkbox onChange={this.onChangeHideAOI} style={{ color: '#FFF', fontSize:'12px', fontWeight:'normal' }} checked={this.state.hide_clients.length > 0 ? true : false}>不看 AOI Solutions GmbH</Checkbox> */}
                        </td>
                        <td>
                            <YearSelector name='CreatedYear' changeSelectedYear={this.changeSelectedCreatedYear.bind(this)} selectedYear={this.state.selectedCreatedYear} />
                        </td>
                        <td>

                            <Space direction='vertical'>
                                <Checkbox onChange={this.onChangeNeedgutschrift} style={{ color: '#FFF' }} checked={this.state.need_gutschrift}>需要 Gutschrift</Checkbox>
                                <Checkbox onChange={this.onChangeReceivedGutschrift} style={{ color: '#FFF' }} checked={this.state.received_gutschrift}>收到 Gutschrift</Checkbox>
                            </Space>
                        </td>
                        <td>
                            <Selector name='Brands' allowClear={true} defaultValue={React.Component.prototype.$intl.get('请选择品牌')} selectorValues={brands} changeSelector={this.changeProductBrand.bind(this)} selectedValue={this.state.brand_id} />
                            {/* <Tooltip title="显示创建日期在4天前的国内库存产品">
                                <Checkbox onChange={this.onChangeChinaStock} style={{ color: '#FFF', fontSize:'12px', fontWeight:'normal' }} checked={this.state.showChinaStock ? true : false}>
                                    显示国内库存到货
                                </Checkbox>
                            </Tooltip> */}
                        </td>
                        <td>
                            {/* <Button bsStyle="info" onClick={this.changeSortDeliveredTime} bsSize="xsmall"><SortAscendingOutlined /></Button> */}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </StyleProvider>
            </ConfigProvider>
        );
    }

}

export default GutschriftProductTableFilter;
